/* eslint-disable no-param-reassign */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-restricted-globals */

import 'intersection-observer';

import React from 'react';
import { NextComponentType } from 'next';
import Head from 'next/head';
import { getCLS, getFCP, getFID, getLCP, getTTFB } from 'web-vitals';
import { ExperimentProvider } from '@havenengineering/module-haven-analytics';
import getConfig from 'next/config';

import '../style/styles.scss';
import RumService from '../services/rum-service';
import { AppContextProvider } from '../providers/appContextProvider';
import { DefaultHeader } from '../module/main-page/component/default-header/default-header';
import { DefaultFooter } from '../module/main-page/component/default-footer/default-footer';
import { AppLoadingProvider } from '../providers/appLoadingProvider';
import { UnleashProvider } from '../providers/unleashProvider';

if (typeof window !== 'undefined') {
  const store: Array<{ name: string; value: number; delta: number }> = [];
  Object.defineProperty(window, '$$havenwvstore', {
    get() {
      return store.map(({ name, value, delta }) => ({ name, value, delta }));
    },
  });
  [getLCP, getCLS, getFCP, getFID, getTTFB].forEach((fn) =>
    fn((metric) => store.push(metric), true),
  );
}

RumService.startMonitoring();

const BourneApp = ({ Component, pageProps }: { Component: NextComponentType; pageProps: any }) => {
  const { unleashSessionVariants, unleashSessionId } = pageProps;

  const {
    publicRuntimeConfig: { amplitudeKey },
  } = getConfig();

  return (
    <ExperimentProvider apiKey={amplitudeKey}>
      <UnleashProvider
        unleashSessionVariants={unleashSessionVariants}
        unleashSessionId={unleashSessionId}
      >
        <AppContextProvider>
          <>
            <div id="searchResultTop" />
            <Head>
              <title>Holidays Search Results | Haven</title>
            </Head>
            <DefaultHeader />
            <AppLoadingProvider>
              <main>
                <Component {...pageProps} />
              </main>
            </AppLoadingProvider>
            <DefaultFooter />
          </>
        </AppContextProvider>
      </UnleashProvider>
    </ExperimentProvider>
  );
};

export default BourneApp;
